/** Algolia accepts at most 1,000 combined filters per query. */
export const ALGOLIA_MAX_COMBINED_FILTERS = 1000;

/** Persistent product availability filters always add three predicates to every query. */
export const PERSISTENT_FILTER_COUNT = 3;

/** Leave room for InstantSearch facet refinements on top of ConfigureSearch filters. */
export const USER_REFINEMENT_FILTER_HEADROOM = 50;

/** Max category-path OR filters for ConfigureSearch (includes user refinement headroom). */
export const MAX_CATEGORY_PATH_FILTERS =
    ALGOLIA_MAX_COMBINED_FILTERS - PERSISTENT_FILTER_COUNT - USER_REFINEMENT_FILTER_HEADROOM;
